import React, { useState } from 'react';

import { CaptureVisit } from './CaptureVisit';
import { PastVisitsSearch } from './PastVisitsSearch';
import { FutureVisitSearch } from './FutureVisitSearch';

import './ParticipantVisitsTab.css';

export const ParticipantVisitsTab = ({
  participant,
  setParticipant,
  context,
  setContext,
  showToaster,
  setSpinnerText,
  toolTipsEnabled,
}) => {
  const [buttonPressed, setButtonPressed] = useState(false);
  const [activeTab, setActiveTab] = useState('captureVisits');
  const [currentScreen, setCurrentScreen] = useState('captureVisits');

  const screenMap = new Map();
  screenMap.set(
    'captureVisits',
    <CaptureVisit
      context={context}
      setContext={setContext}
      participant={participant}
      setParticipant={setParticipant}
      setCurrentScreen={setCurrentScreen}
      toolTipsEnabled={toolTipsEnabled}
      setSpinnerText={setSpinnerText}
      showToaster={showToaster}
    />
  );
  screenMap.set(
    'pastVisits',
    <PastVisitsSearch
      context={context}
      participant={participant}
      setParticipant={setParticipant}
      toolTipsEnabled={toolTipsEnabled}
      setSpinnerText={setSpinnerText}
      showToaster={showToaster}
    />
  );
  screenMap.set('futureVisits', <FutureVisitSearch participant={participant} />);

  const handleNavigationClick = (tab) => {
    setActiveTab(tab);
    setCurrentScreen(tab);
    setButtonPressed(true);
  };

  return (
    <div className="participants-visit-tab-container">
      <div className="participants-visit-tab-tab-container">
        <div
          className={'participants-visit-tab capture ' + (activeTab === 'captureVisits' ? 'active-tab' : null)}
          onClick={() => handleNavigationClick('captureVisits')}
        >
          Capture Visits
        </div>
        <div
          className={'participants-visit-tab past ' + (activeTab === 'pastVisits' ? 'active-tab' : null)}
          onClick={() => handleNavigationClick('pastVisits')}
        >
          Past Visits
        </div>
        <div
          className={'participants-visit-tab future ' + (activeTab === 'futureVisits' ? 'active-tab' : null)}
          onClick={() => handleNavigationClick('futureVisits')}
        >
          Future Visits
        </div>
      </div>
      <div className={`participants-visit-tab-content ${activeTab}`}>
        {buttonPressed ? screenMap.get(currentScreen) : screenMap.get('captureVisits')}
      </div>
    </div>
  );
};
